export const TYPES = [
  {
    id: 1,
    name: "compliance",
    value: 1,
    i18n: true,
  },
  {
    id: 2,
    name: "retail",
    value: 2,
    i18n: true,
  },
];

export const ASSIGN_ON = [
  {
    id: 1,
    name: "audience",
    value: 1,
    i18n: true,
  },
  {
    id: 3,
    name: "program_completion",
    value: 3,
    i18n: true,
  },
];

export const TRAINING_TYPES = [
  {
    id: "required",
    name: "training_required",
    value: false,
    i18n: true,
  },
  {
    id: "optional",
    name: "optional",
    value: true,
    i18n: true,
  },
];
